import { useTranslation } from 'react-i18next';

export default function KeyInfo() {
  const { t } = useTranslation();

  const sections = [
    {
      title: t('keyinfo_location_title'),
      items: [
        t('keyinfo_location_1'),
        t('keyinfo_location_2'),
        t('keyinfo_location_3'),
        t('keyinfo_location_4'),
        t('keyinfo_location_5'),
        t('keyinfo_location_6'),
      ],
    },
    {
      title: t('keyinfo_property_title'),
      items: [
        t('keyinfo_property_1'),
        t('keyinfo_property_2'),
        t('keyinfo_property_3'),
        t('keyinfo_property_4'),
        t('keyinfo_property_5'),
        t('keyinfo_property_6'),
      ],
    },
    {
      title: t('keyinfo_layout_title'),
      items: [
        t('keyinfo_layout_1'),
        t('keyinfo_layout_2'),
        t('keyinfo_layout_3'),
        t('keyinfo_layout_4'),
        t('keyinfo_layout_5'),
        t('keyinfo_layout_6'),
        t('keyinfo_layout_7'),
        t('keyinfo_layout_8'),
        t('keyinfo_layout_9'),
        t('keyinfo_layout_10'),
      ],
    },
    {
      title: t('keyinfo_materials_title'),
      items: [
        t('keyinfo_materials_1'),
        t('keyinfo_materials_2'),
        t('keyinfo_materials_3'),
        t('keyinfo_materials_4'),
        t('keyinfo_materials_5'),
        t('keyinfo_materials_6'),
        t('keyinfo_materials_7'),
      ],
    },
    {
      title: t('keyinfo_pool_title'),
      items: [
        t('keyinfo_pool_1'),
        t('keyinfo_pool_2'),
        t('keyinfo_pool_3'),
        t('keyinfo_pool_4'),
        t('keyinfo_pool_5'),
        t('keyinfo_pool_6'),
      ],
    },
    {
      title: t('keyinfo_parking_title'),
      items: [
        t('keyinfo_parking_1'),
        t('keyinfo_parking_2'),
        t('keyinfo_parking_3'),
        t('keyinfo_parking_4'),
      ],
    },
    {
      title: t('keyinfo_energy_title'),
      items: [
        t('keyinfo_energy_1'),
        t('keyinfo_energy_2'),
        t('keyinfo_energy_3'),
        t('keyinfo_energy_4'),
        t('keyinfo_energy_5'),
        t('keyinfo_energy_6'),
        t('keyinfo_energy_7'),
      ],
    },
    {
      title: t('keyinfo_tech_title'),
      items: [
        t('keyinfo_tech_1'),
        t('keyinfo_tech_2'),
        t('keyinfo_tech_3'),
        t('keyinfo_tech_4'),
        t('keyinfo_tech_5'),
        t('keyinfo_tech_6'),
        t('keyinfo_tech_7'),
      ],
    },
  ];

  return (
    <section className="py-24 bg-gray-50">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
            {t('keyinfo_main_title')}
          </h2>
          <p className="text-xl text-gray-600">
            {t('keyinfo_main_subtitle')}
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {sections.map((section, idx) => (
            <div key={idx} className="bg-white rounded-xl p-8 shadow-sm hover:shadow-md transition-shadow">
              <h3 className="text-2xl font-bold text-gray-900 mb-6 pb-4 border-b-2 border-gray-900">
                {section.title}
              </h3>
              <ul className="space-y-3">
                {section.items.map((item, itemIdx) => (
                  <li key={itemIdx} className="flex items-start gap-3">
                    <i className="ri-check-line text-gray-900 text-xl flex-shrink-0 mt-0.5"></i>
                    <span className="text-gray-700 text-base">{item}</span>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
